<template>
  <section
    class=""
    style="background: #f6f6f6; color: black; padding: 0 12px 0 12px"
  >
    <div class="container">
      <div class="page-title-customs">
        <div class="text-center">
          <div class="capital-label-wrapper">
            <!-- CAPITAL LABEL -->
            <span
              class="capital-label"
              style="
                padding: 8px 20px;
                padding-bottom: 10px;
                font-size: 10.3px;
                letter-spacing: -0.5px;
                color: #5a5d67;
                font-weight: 400;
              "
            >
              {{ props.capital }}
            </span>
            <!-- CAPITAL LABEL -->
          </div>
        </div>

        <h2 class="page-title-h2 text-black text-center">{{ props.title }}</h2>
      </div>
    </div>
  </section>
  <section
    style="
      background: #f6f6f6;
      color: black;
      padding-top: 19px;
      padding-bottom: 23px;
    "
  >
    <h2 class="text-black text-center page-title-sub">
      {{ props.description }}
    </h2>
    <div class="section-divider-custom"></div>
  </section>
</template>
<script setup>
const props = defineProps(["capital", "title", "description"]);
</script>
<style scoped>
.page-title-customs {
  padding-top: 60px;
  padding-bottom: 20px;
}

.page-title-h2 {
  margin-top: 42px;
  font-size: 44px;
  font-weight: 600;
  font-family: "Caslon-Pro";
}

.page-title-sub {
  font-size: 1.91rem;
  letter-spacing: -1.5px;
  font-weight: 500;
}

.section-divider-custom {
  display: block;
  width: 7.9%;
  height: 8px;
  border-radius: 4px;
  background: var(--global-color-primary);
  margin: 64px auto;
  margin-bottom: 0px;
}
</style>
